import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getItemStockLimit,
  getAllItemStockLimit,
  getNext,
  getPrevious,
  getPageItemStockLimit,
  createItemStockLimit,
  updateItemStockLimit,
  handleSearch,
} from "./thunk";

const initialState = {
  itemStockLimits: [],
  edit: false,
  itemStockLimit: null,
  count: null,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingItemStockLimit: false,
  loadingNext: false,
};

export const itemStockLimitSlice = createSlice({
  name: "itemStockLimit",
  initialState,
  reducers: {
    itemStockLimitEditSuccess: (state, action) => {
      state.edit = true;
      state.itemStockLimit = state.itemStockLimits.find((itemStockLimit) => itemStockLimit.id === action.payload);
    },
    clearAllItemStockLimit: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingItemStockLimit = false;
      state.itemStockLimit = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNext.pending, (state) => {
      state.loadingNext = true;
    });
    builder.addCase(getNext.fulfilled, (state, action) => {
      state.loadingNext = false;
      state.itemStockLimits = [...state.itemStockLimits, ...action.payload.results];
      state.next = action.payload.next;
    });
    builder.addCase(getNext.rejected, (state) => {
      state.loadingNext = false;
    });
    builder.addCase(createItemStockLimit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createItemStockLimit.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createItemStockLimit.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateItemStockLimit.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateItemStockLimit.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateItemStockLimit.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(isAnyOf(getItemStockLimit.pending, handleSearch.pending), (state) => {
      state.loadingItemStockLimit = true;
    });
    builder.addMatcher(isAnyOf(getItemStockLimit.fulfilled, handleSearch.fulfilled), (state, action) => {
      state.loadingItemStockLimit = false;
      state.itemStockLimits = action.payload.results;
      state.count = action.payload.count;
      state.previous = action.payload.previous;
      state.next = action.payload.next;
    });
    builder.addMatcher(isAnyOf(getItemStockLimit.rejected, handleSearch.rejected), (state) => {
      state.loadingItemStockLimit = false;
    });
  },
});

export const { itemStockLimitEditSuccess, clearAllItemStockLimit } = itemStockLimitSlice.actions;

export default itemStockLimitSlice.reducer;
